<template>
    <div>
        <loading-component :value="loading"/>
        <v-select
                class="pa-4"
                label="Filter"
                :items="[ {value: null,text:'No Filter'},...api.CONSTANTS.ACCOUNT_ENTRY_TYPES.map( item => ({value: item , text:item}))]"
                v-model="filter"
                append-icon="fa fa-filter"
        />
        <DataTable
                ref="dataTable"
                :url="provider == 'captains' ? api.ACTIONS.CAPTAIN_TRANSACTIONS(id) : api.ACTIONS.PASSENGER_TRANSACTIONS(id)"
                :initial-url-search-params="params"
                :enable-edit="false"
                :enable-add="false"
                :conditional-action="conditionalActions"
                :fields-hidden-main="['entry_id','debit','credit','amount','updated_at','deleted_at','penalty_id', 'is_credit']"
                :fields-extra-main="fieldsExtraMain"
                :actions-extra-main="actionsExtraMain"
                :formatter="formatter"
                disable-search
        />
    </div>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        props: ['id', 'provider'],
        name: "transactions",
        data() {
            return {
                loading: false,
                filter: null,
                params: new URLSearchParams()
            }
        },
        components: {LoadingComponent, DataTable},
        watch: {
            filter(val) {
                this.$refs.dataTable.reset();
                const params = new URLSearchParams();
                if (val != null) {
                    params.append('filter', val);
                }
                this.params = params;

            }
        },
        computed: {
            formatter() {
                return {
                    note(value) {
                        if (value == null)
                            return "No Note";
                        else
                            return value;
                    },
                    value(value) {
                        if(value > 0) {
                            return `<span style="color: lightgreen">${Math.abs(value)}</span>`;
                        }
                        return `<span style="color: red">${Math.abs(value)}</span>`;
                    },
                    wallet(value) {
                        if(value > 0) {
                            return `<span style="color: lightgreen">${value}</span>`;
                        }
                        return `<span style="color: red">${value}</span>`;
                    }
                }
            },
            conditionalActions() {
                return {
                    delete({penalty_id}) {
                        return penalty_id != null;
                    }
                }
            },
            actionsExtraMain() {
                return {
                    delete: {
                        action: async (item) => {
                            this.loading = true;
                            this.axios.delete(this.api.ACTIONS.PENALTY + '/' + item.penalty_id)
                                .then(
                                    () => {
                                        this.$refs.dataTable.removeItemFromTable(item);
                                        window.getApp.$emit("SHOW_TOAST", "DELETED", "GREEN");
                                    }
                                )
                                .catch(
                                    ({response}) => {
                                        console.log(response);
                                        window.getApp.$emit("SHOW_TOAST", "COULDN'T DELETE (CHECK ERROR LOG)", "RED");
                                    }
                                )
                                .finally(
                                    () => this.loading = false
                                )
                        }
                    }
                }
            },
            fieldsExtraMain() {
                return {
                    value({debit, amount}) {
                        return (debit != null ? -1 : 1) * amount;
                    }
                }
            }
        }
    }
</script>

<style>
    .credit {
        background: lightgreen;
    }
    .debit {
        background: red;
    }
</style>